module.exports = "data:image/svg+xml;base64,77u/PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjxzdmcgdmVyc2lvbj0iMS4xIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgd2lkdGg9IjUycHgiIGhlaWdodD0iMzhweCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCiAgPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSAtNTU1IC0yODkgKSI+DQogICAgPHBhdGggZD0iTSA1NTUgMzI3ICBMIDU4MSAyODkgIEwgNjA3IDMyNyAgTCA1NTUgMzI3ICBaICIgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSIjZmZmZmZmIiBzdHJva2U9Im5vbmUiIC8+DQogIDwvZz4NCjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_start.svg
// module id = OFeQ
// module chunks = 1